import React from "react";
import { Flex } from "@fluentui/react-northstar";
import LabelView from "../../../LabelView";
import { EDUCATION_LEVEL_LIST } from "../../../../../../pages/CollaboratorFactsheet/components/BlockInfosPerso";

const QualificationAndJobContent = ({
    job_title,
    contract_type,
    contract_status,
    coefficient,
    position,
    contract_country,
    diploma,
}) => {
    const is_fr = contract_country?.toLowerCase() === "fr";

    const diplomaName = EDUCATION_LEVEL_LIST.find(
        (level) => level.id === diploma
    )?.header;

    return (
        <Flex fill column gap="gap.medium">
            <LabelView label="Poste" content={job_title} />
            <LabelView label="Type de contrat" content={contract_type?.name} />
            <LabelView
                label={is_fr ? "Statut" : "CSP"}
                content={contract_status?.name}
            />
            <LabelView label={"Formation"} content={diplomaName} />
            {is_fr && (
                <>
                    <LabelView label="Position" content={position} />
                    <LabelView label="Coefficient" content={coefficient} />
                </>
            )}
        </Flex>
    );
};

export default QualificationAndJobContent;
